import React from "react";
import { useStateValue } from "../App";

export const CalendarSharerItems = ({ filteredEvents, onShare }) => {
  const [{ year, uid, userCal }] = useStateValue();


  const link = userCal?.edit_hash
    ? wp.url + '/?agenda=&bekijk=' + userCal.edit_hash
    : window.location.href;

  const shareWithFacebook = e => {
    e.preventDefault();
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      link
    )}`;
    shareLinkWithModal(url);
    if (typeof onShare == "function") onShare();
  };

  const shareWithTwitter = e => {
    e.preventDefault();
    fetch(`${wp.url}?action=get_calendar_share_message&type=twitter`, {
      method: "GET"
    })
      .then(res => res.json())
      .then(res => {
        const twitterMessage = res.message
          .replace("{year}", year)
          .replace("{link_to_calendar}", link)
          .replace("{my_or_the}", uid ? "mijn" : "de");

        const url = `https://twitter.com/intent/tweet?url&text=${
          twitterMessage !== null ? encodeURIComponent(twitterMessage) : ""
        }`;

        shareLinkWithModal(url);

        if (typeof onShare == "function") onShare();
      });
  };

  const shareWithLinkedIn = e => {
    e.preventDefault();
    fetch(`${wp.url}?action=get_calendar_share_message&type=linkedin`, {
      method: "GET"
    })
      .then(res => res.json())
      .then(res => {
        const linkedinMessage = res.message
          .replace("{year}", year)
          .replace("{link_to_calendar}", link)
          .replace("{my_or_the}", uid ? "mijn" : "de");

        const url = `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
          link
        )}&title=${linkedinMessage}&description${linkedinMessage}`;

        shareLinkWithModal(url);

        if (typeof onShare == "function") onShare();
      });
  };

  const shareWithEmail = e => {
    e.preventDefault();

    const icsLink = `${
      wp.url
    }?action=abonneer&id=${userCal.edit_hash}`;

    Promise.all([
      fetch(`${wp.url}?action=get_calendar_share_message&type=mail`).then(res =>
        res.json()
      )
    ]).then(([res]) => {
      const emailMessage = res.message
        .replace("{year}", year)
        .replace("{link_to_calendar}", link)
        .replace("{my_or_the}", uid ? "mijn" : "de")
        .replace("{link_to_ics_file}", icsLink);


      const emailSubject = res.title
        .replace("{year}", year)
        .replace("{my_or_the}", uid ? "mijn" : "de");

      if (typeof onShare == "function") onShare();

      window.location = `mailto:?subject=${emailSubject}&body=${encodeURIComponent(
        emailMessage
      )}`;
    });
  };

  const shareLinkWithModal = url => {
    window.open(url, "share-dialog", "width=626,height=436");
    return false;
  };

  return (
    <div className="sharer__items">
      <button
        onClick={shareWithFacebook}
        target="_blank"
        className="btn btn--share facebook"
      ></button>
      <button
        onClick={shareWithTwitter}
        className="btn btn--share twitter"
      ></button>
      <button
        onClick={shareWithLinkedIn}
        className="btn btn--share linkedin"
      ></button>
      {/* <a
        href={`mailto:?subject=${title}&body=${encodeURIComponent(`
          Bekijk de jaarkalender op: ${_link}
        `)}`}
        className="btn btn--share email"
      ></a> */}
      <button className="btn btn--share email" onClick={shareWithEmail}>
        <span className="screen-reader-text">
          Deel jaarkalender via een Email
        </span>
      </button>
    </div>
  );
};
